import { useEffect, useState } from 'react';

const getWindowDimensions = () => ({
	width: window.innerWidth,
	height: window.innerHeight,
});

const MOBILE_WIDTH_MAX = 848;

export const useWindowDimensions = () => {
	const [dimensions, setDimensions] = useState(getWindowDimensions());

	useEffect(() => {
		const onResize = () => {
			setDimensions(getWindowDimensions());
		};

		window.addEventListener('resize', onResize);
		return () => window.removeEventListener('resize', onResize);
	}, []);

	return {
		width: dimensions.width,
		isMobileScreen: dimensions.width < MOBILE_WIDTH_MAX,
	};
};
